import { trackEvent } from 'lib/ui-analytics';
import { TEALIUM_BRAND, TRACKING_ACTION, TRACKING_COMPARE, TRACKING_INTERACTION, PROD_CATEGORY } from '../Constants';

export const utagGoToCompare = (cruises, selectedCruises, locale, brand) => {
  const interaction = createCompareInteraction(cruises, selectedCruises, locale, brand);
  trackEvent(interaction);
};

const createCompareInteraction = (cruises, selectedCruises, locale, brand) => {
  const cardPosition = [];
  const csDepartureDate = [];
  const prodCategory = [];
  const prodCost = [];
  const productSku = [];
  const prodQuantity = [];
  const groupId = [];
  const productEvent = [];

  for (let selectedCruise of selectedCruises) {
    cardPosition.push(cruises.findIndex(cruise => cruise.id === selectedCruise.id) + 1);
    csDepartureDate.push(selectedCruise.lowestPriceSailing?.startDate);
    prodCategory.push(PROD_CATEGORY.booking);
    prodCost.push(Math.round(selectedCruise.lowestPriceSailing?.lowestStateroomClassPrice?.price?.value));
    productSku.push(selectedCruise.masterSailing?.itinerary?.code);
    prodQuantity.push(1);
    groupId.push(selectedCruise.id);
    productEvent.push(TRACKING_COMPARE.COMPARE_START);
  }
  
  return {
    'cardPosition': cardPosition,
    'country': locale?.country,
    'currency': locale?.currency,
    'language': locale?.language,
    'siteSection': TEALIUM_BRAND[brand].siteSection,
    'eventType': TRACKING_ACTION.INTERACTION,
    'interaction': TRACKING_INTERACTION.COMPARE.START,
    'pageName': TEALIUM_BRAND[brand].pageName,
    'departureDate': csDepartureDate,
    'prodCategory': prodCategory,
    'prodCost': prodCost,
    'prodSku': productSku,
    'prodQuantity': prodQuantity,
    'groupId': groupId,
    'productEvent': productEvent,
  };
};